import { Component, OnInit } from '@angular/core';

declare var $: any

@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.scss']
})
export class PublicationsComponent implements OnInit {

  papers = {
    submitted: [
      'Yang, Y*; Sun, S, Tan, J. (2022). Rapid Determination of the Roasting Degree of Cocoa Beans by Extreme Learning Machine (ELM)-based Imaging Analysis. Journal of food engineering. Submitted',
      'Saeed, F; Sun, S; Snider, J; Liu, T; Li, C. (2022).Point - and voxel - based 3D deep learning for plant part segmentation and architectural trait extraction.IEEE Transactions on Geoscience and Remote Sensing.Submitted.',
      'Yang, Y *; Wang, X; Liu, Z; Huang, M; Sun, S; Zhu Q. (2022).An improved DEtection TRansformer deep learning network for multi - size peach detection using an RGB - D camera in orchards.neural computing and applications.Submitted.',
      'Ahmad, Z; Fearns, P; Lu, B; Fountas, S; Zare, M; Schirrmann, M; Jimenez - Berni, J; Siłuch, M; Sun, S; Nussbaum, M. (2022).Precision irrigation methods for high water use efficiency: Advances, Challenges and Forecast.Computers and Electronics in Agriculture.Submitted',
      'Yang, Y *; Sun, S; Pan, L; Huang, M; Zhu, Q. (2022).Predictions of multiple food quality parameters using near - infrared spectroscopy with a novel multi - task genetic programming approach.Food Control.Submitted.'
    ],
    publicated: [
        {
        title: '3D skeletonization and phenotyping for soybean root system architecture using a bio-inspired algorithm',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0168169925009962',
        authors: 'Xuehai Zhou, Tianzi Yang, Rui Xu, Alexander Bucksch, Pierre Dutilleul, Davoud Torkamaneh, Shangpeng Sun',
        publisher: '',
        date: '2025',
        journal: 'Computers and Electronics in Agriculture',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Predictive Modeling, Pattern Recognition, and Spatiotemporal Representations of Plant Growth in Simulated and Controlled Environments: A Comprehensive Review',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S2643651525000950',
        authors: 'Mohamed Debbagh, Shangpeng Sun, Mark Lefsrud',
        publisher: '',
        date: '2025',
        journal: 'Plant Phenomics',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Augmented reality for food quality assessment: Bridging the physical and digital worlds',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0260877423004910?casa_token=ZkKifHWJrQkAAAAA:vm-02U6_PoytzOu5kdwqBdH-Ecu_fHKqgMtPaH_vTAEgBXfUcxmIQwP8_k_MCdDOXxxNTwLD6A',
        authors: 'Jacob Tizhe Liberty, Shangpeng Sun, Christopher Kucha, Akinbode A. Adedeji, Gbabo Agidi, Michael O. Ngadi',
        publisher: '',
        date: '2024',
        journal: 'Journal of Food Engineering',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: '3D-GhostNet: A novel spatial-spectral algorithm to improve foodborne bacteria classification coupled with hyperspectral microscopic imaging technology',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0925400524004350',
        authors: 'Rui Kang, Shangpeng Sun, Qin Ouyang, Jiaxing Huang, Bosoon Park',
        publisher: '',
        date: '2024',
        journal: 'Sensors and Actuators B: Chemical',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'A Novel Jujube Tree Trunk and Branch Salient Object Detection Method for Catch-and-Shake Robotic Visual Perception',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0957417424008881',
        authors: 'Zhouzhou Zheng, Jianxin Dong, Yixue Liu, Yichen Qiao, Shangpeng Sun, Yuxiang Huang',
        publisher: '',
        date: '2024',
        journal: 'Expert Systems with Applications',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Towards Real Scenery: A Light-weight Tomato Growth Inspection Algorithm for Leaf Disease Detection and Fruit Counting',
        viewUrl: '',
        detailUrl: 'https://spj.science.org/doi/full/10.34133/plantphenomics.0174',
        authors: 'Rui Kang, Jiaxin Huang, Xuehai Zhou, Ni Ren, Shangpeng Sun',
        publisher: '',
        date: '2024',
        journal: 'Plant Phenomics',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Advancing tracking-by-detection with MultiMap: Towards occlusion-resilient online multiclass strawberry counting',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0957417424014544',
        authors: 'Xuehai Zhou, Yuyang Zhang, Xintong Jiang, Kashif Riaz, Phil Rosenbaum, Mark Lefsrud, Shangpeng Sun',
        publisher: '',
        date: '2024',
        journal: 'Expert Systems with Applications',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Exploring Vibration Characteristics of Winter Jujube Trees for Jujube Fruit Harvesting (under review)',
        viewUrl: '',
        detailUrl: '',
        authors: 'Zhouzhou Zheng, Jianxin Dong, Yixue Liu, Yichen Qiao, Shangpeng Sun, Yuxiang Huang',
        publisher: '',
        date: '2024',
        journal: 'Biosystem Engineering',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Graph-Transformer with Spatial-Spectral Features Fusion for Hyperspectral Image Classification (under review)',
        viewUrl: '',
        detailUrl: '',
        authors: 'Zhouzhou Zheng, Yixue Liu, Xintong Jiang, Mohamed Debbagh, Xuehai Zhou, Shangpeng Sun, Yuxiang Huang',
        publisher: '',
        date: '2024',
        journal: 'IEEE Transactions on Geoscience and Remote Sensing',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Spinach Yield Mapping Using Multispectral UAV Imagery',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S2772375523002162',
        authors: 'X Jiang, S Sun, V Adamchuk, G Weisman, P Ramsay, AR Rincon',
        publisher: '',
        date: '2023',
        journal: 'Smart Agricultural Technology',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'A dynamic object counting method for strawberry fruits using vision transformer networks and kalman filter tracking',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=tyNAkb4AAAAJ&citation_for_view=tyNAkb4AAAAJ:u-x6o8ySG0sC',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=54240',
        authors: 'Xuehai Zhou, Yuyang Zhang, Shangpeng Sun, Phil Rosenbaum',
        date: '2023',
        conference: '2023 ASABE Annual International Meeting',
        award: 'ITSC paper award',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 0
      },
      {
        title: 'Eff-3DPSeg: 3D organ-level plant shoot segmentation using annotation-efficient point clouds',
        viewUrl: '',
        detailUrl: 'https://spj.science.org/doi/10.34133/plantphenomics.0080',
        authors: 'L Luo, X Jiang, Y Yang, ERA Samy, M Lefsrud, V Hoyos-Villegas, S Sun',
        publisher: '',
        date: '2023',
        journal: 'Plant phenomics',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'PEAMATL: A strategy for developing near-infrared spectral prediction models under domain shift using self-supervised transfer learning',
        viewUrl: '',
        detailUrl: 'https://ieeexplore.ieee.org/abstract/document/10121191?casa_token=_7PgpmY9uqgAAAAA:btWZBeHz_LMQ_gkmvZGswlbcrH4CMhcOT6F_vQFc4bI32csR3tZlp3O_BKl246UONTby4IlsNQ',
        authors: 'Yu Yang, Shangpeng Sun, Min Huang, and Qibing Zhu',
        publisher: '',
        date: '2023',
        journal: 'IEEE Transactions on Instrumentation and Measurement',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Rapid determination of the roasting degree of cocoa beans by extreme learning machine (ELM)-based imaging analysis',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S2666154322001703',
        authors: 'Yu Yang, Ahmed G. Darwish, Islam El-Sharkawy, Qibing Zhu, Shangpeng Sun, and Juzhong Tan',
        publisher: '',
        date: '2022',
        journal: 'Journal of Agriculture and Food Research',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Cotton plant part 3D segmentation and architectural trait extraction using point voxel convolutional neural networks',
        viewUrl: '',
        detailUrl: 'https://plantmethods.biomedcentral.com/articles/10.1186/s13007-023-00996-1',
        authors: 'Farah Saeed, Shangpeng Sun, Javier Rodriguez‑Sanchez, John Snider, Tianming Liu and Changying Li',
        publisher: '',
        date: '2023',
        journal: 'Plant Methods',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'An improved DEtection TRansformer deep learning network for multi-size peach detection using an RGB-D camera in orchards (accepted)',
        viewUrl: '',
        detailUrl: '',
        authors: 'Yang, Y *; Wang, X; Liu, Z; Huang, M; Sun, S; Zhu Q',
        publisher: '',
        date: '2022',
        journal: 'Intelligent Data Analysis',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Precision irrigation methods for high water use efficiency: Advances, Challenges and Forecast (under review)',
        viewUrl: '',
        detailUrl: '',
        authors: 'Ahmad, Z; Fearns, P; Lu, B; Fountas, S; Zare, M; Schirrmann, M; Jimenez - Berni, J; Siłuch, M; Sun, S; Nussbaum, M',
        publisher: '',
        date: '2022',
        journal: 'Computers and Electronics in Agriculture',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        title: 'Predictions of multiple food quality parameters using near-infrared spectroscopy with a novel multi-task genetic programming approach',
        viewUrl: '',
        detailUrl: 'https://www.sciencedirect.com/science/article/abs/pii/S0956713522005825?via%3Dihub',
        authors: 'Yu Yang, Shangpeng Sun, Leiqing Pan, Min Huang, Qibing Zhu',
        publisher: '',
        date: '2022',
        journal: 'Food Control',
        volume: '',
        issue: '',
        pages: '',
        citedBy: 0
      },
      {
        // 标题
        title: 'In-field high throughput phenotyping and cotton plant growth analysis using LiDAR',
        // 概览URL
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:2osOgNQ5qMEC',
        // 全文URL
        detailUrl: 'https://www.frontiersin.org/articles/10.3389/fpls.2018.00016/full',
        // 作者列表
        authors: 'Shangpeng Sun, Changying Li, Andrew H Paterson, Yu Jiang, Rui Xu, Jon S Robertson, John L Snider, Peng W Chee',
        // 由那个机构发行发布
        publisher: 'Frontiers Media SA',
        // 发布的日期
        date: '2018-1-22',
        // 杂志或期刊名称
        journal: 'Frontiers in Plant Science',
        // 卷，册
        volume: '9',
        // 发行
        issue: '0',
        // 页数
        pages: '16',
        // 被引用次数
        citedBy: 92
      },
      {
        title: 'In-field high-throughput phenotyping of cotton plant height using LiDAR',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:UeHWp8X0CEIC',
        detailUrl: 'https://www.mdpi.com/192162',
        authors: 'Shangpeng Sun, Changying Li, Andrew H Paterson',
        publisher: 'Mdpi',
        date: '2017-4-18',
        journal: 'Remote Sensing',
        volume: '9',
        issue: '4',
        pages: '377',
        citedBy: 77
      },
      {
        title: 'Aerial images and convolutional neural network for cotton bloom detection',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:IjCSPb-OGe4C',
        detailUrl: 'https://www.frontiersin.org/articles/10.3389/fpls.2017.02235/full',
        authors: 'Rui Xu, Changying Li, Andrew H Paterson, Yu Jiang, Shangpeng Sun, Jon S Robertson',
        publisher: 'Frontiers Media SA',
        date: '2018-2-16',
        journal: 'Frontiers in plant science',
        volume: '8',
        issue: '0',
        pages: '2235',
        citedBy: 65
      },
      {
        title: 'GPhenoVision: A ground mobile system with multi-modal imaging for field-based high throughput phenotyping of cotton',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:9yKSN-GCB0IC',
        detailUrl: 'https://www.nature.com/articles/s41598-018-19142-2',
        authors: 'Yu Jiang, Changying Li, Jon S Robertson, Shangpeng Sun, Rui Xu, Andrew H Paterson',
        publisher: 'Nature Publishing Group',
        date: '2018-1-19',
        journal: 'Scientific reports',
        volume: '8',
        issue: '1',
        pages: '1-15',
        citedBy: 52
      },
      {
        title: 'Three-dimensional photogrammetric mapping of cotton bolls in situ based on point cloud segmentation and clustering',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:LkGwnXOMwfcC',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0924271619302990',
        authors: 'Shangpeng Sun, Changying Li, Peng W Chee, Andrew H Paterson, Yu Jiang, Rui Xu, Jon S Robertson, Jeevan Adhikari, Tariq Shehzad',
        date: '2020-2-1',
        journal: 'ISPRS Journal of Photogrammetry and Remote Sensing',
        volume: '160',
        issue: '0',
        pages: '195-207',
        publisher: 'Elsevier',
        citedBy: 46
      },
      {
        title: 'Simulation of an autonomous mobile robot for LiDAR-based in-field phenotyping and navigation',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:Se3iqnhoufwC',
        detailUrl: 'https://www.mdpi.com/748950',
        authors: 'Jawad Iqbal, Rui Xu, Shangpeng Sun, Changying Li',
        date: '2020-6-21',
        journal: 'Robotics',
        volume: '9',
        issue: '2',
        pages: '46',
        publisher: 'MDPI',
        citedBy: 35
      },
      {
        title: 'Quantitative analysis of cotton canopy size in field conditions using a consumer-grade RGB-D camera',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:Y0pCki6q_DkC',
        detailUrl: 'https://www.frontiersin.org/articles/10.3389/fpls.2017.02233/full',
        authors: 'Yu Jiang, Changying Li, Andrew H Paterson, Shangpeng Sun, Rui Xu, Jon Robertson',
        date: '2018-1-30',
        journal: 'Frontiers in plant science',
        volume: '8',
        issue: '0',
        pages: '2233',
        publisher: 'Frontiers Media SA',
        citedBy: 27
      },
      {
        title: 'Image processing algorithms for infield single cotton boll counting and yield prediction',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:_FxGoFyzp5QC',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0168169919306209',
        authors: 'Shangpeng Sun, Changying Li, Andrew H Paterson, Peng W Chee, Jon S Robertson',
        date: '2019-11-1',
        journal: 'Computers and electronics in agriculture',
        volume: '166',
        issue: '0',
        pages: '104976',
        publisher: 'Elsevier',
        citedBy: 23
      },
      {
        title: 'DeepFlower: a deep learning-based approach to characterize flowering patterns of cotton plants in the field',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:hqOjcs7Dif8C',
        detailUrl: 'https://plantmethods.biomedcentral.com/articles/10.1186/s13007-020-00698-y',
        authors: 'Yu Jiang, Changying Li, Rui Xu, Shangpeng Sun, Jon S Robertson, Andrew H Paterson',
        date: '2020-12',
        journal: 'Plant methods',
        volume: '16',
        issue: '1',
        pages: '1-17',
        publisher: 'BioMed Central',
        citedBy: 15
      },
      {
        title: 'Fault diagnosis in railway track circuits using support vector machines',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:qjMakFHDy7sC',
        detailUrl: 'https://ieeexplore.ieee.org/abstract/document/6786133/',
        authors: 'Shangpeng Sun, Huibing Zhao',
        date: '2013-12-4',
        conference: '2013 12th International Conference on Machine Learning and Applications',
        volume: '2',
        issue: '0',
        pages: '345-350',
        publisher: 'IEEE',
        citedBy: 11
      },
      {
        title: 'High resolution 3D terrestrial LiDAR for cotton plant main stalk and node detection',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:0EnyYjriUFMC',
        detailUrl: 'https://www.sciencedirect.com/science/article/pii/S0168169921002933',
        authors: 'Shangpeng Sun, Changying Li, Peng W Chee, Andrew H Paterson, Cheng Meng, Jingyi Zhang, Ping Ma, Jon S Robertson, Jeevan Adhikari',
        date: '2021-8-1',
        journal: 'Computers and Electronics in Agriculture',
        volume: '187',
        issue: '0',
        pages: '106276',
        publisher: 'Elsevier',
        citedBy: 7
      },
      {
        title: 'The method of fault detection of compensation capacitor in jointless track circuit based on phase space reconstruction',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:YsMSGLbcyi4C',
        detailUrl: 'https://scholar.google.com/scholar?cluster=18436397631151798978&hl=en&oi=scholarr',
        authors: 'Shangpeng Sun, Huibing Zhao',
        date: '2012-10',
        journal: 'Journal of the China railway society',
        volume: '34',
        issue: '10',
        pages: '79-84',
        publisher: 'China Railway Society, 10 Fuxing Rd. Beijing 100844 China',
        citedBy: 6
      },
      {
        title: '3D computer vision and machine learning based technique for high throughput cotton boll mapping under field conditions',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:WF5omc3nYNoC',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=49285',
        authors: 'Shangpeng Sun, Changying Li, Andrew Paterson, Yu Jiang, Jon Robertson',
        date: '2018',
        conference: '2018 ASABE Annual International Meeting',
        award: 'ITSC paper award',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 5
      },
      {
        title: 'A fault diagnosis approach for railway track circuits trimming capacitors using EMD and teager energy operator',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:W7OEmFMy1HYC',
        detailUrl: 'https://books.google.com/books?hl=en&lr=&id=f7eE3ZaTdMcC&oi=fnd&pg=PA167&dq=info:21ScSr-Vz80J:scholar.google.com&ots=a8xARi0jbn&sig=btI4vwNygfltkfXQMufOhHSHuOQ',
        authors: 'SP Sun, HB Zhao, G Zhou',
        date: '2013',
        journal: 'Computers in Railways XIII: Computer System Design and Operation in the Railway and Other Transit Systems',
        volume: '127',
        issue: '0',
        pages: '167',
        publisher: 'WIT Press',
        citedBy: 4
      },
      {
        title: 'Height estimation for blueberry bushes using LiDAR based on a field robotic platform',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:d1gkVwhDpl0C',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=47027',
        authors: 'Shangpeng Sun, Changying Li',
        date: '2016',
        conference: '2016 ASABE Annual International Meeting',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 3
      },
      {
        title: 'Research on Method for Calculation of Shunt Resistances of Track Circuit Using Electrical Contact Theory',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:u-x6o8ySG0sC',
        detailUrl: 'https://scholar.google.com/scholar?cluster=2465962426338945926&hl=en&oi=scholarr',
        authors: 'Shangpeng Sun, Huibing Zhao, Dewang Chen',
        date: '2014',
        journal: 'Journal of the China Railway Society',
        volume: '36',
        issue: '3',
        pages: '32-35',
        publisher: '',
        citedBy: 3
      },
      {
        title: 'In-field high throughput phenotyping and phenotype data analysis for cotton plant growth using LiDAR',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:zYLM7Y9cAGgC',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=48053',
        authors: 'Shangpeng Sun, Changying Li',
        date: '2017',
        conference: '2017 ASABE Annual International Meeting',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 2
      },
      {
        title: 'Three-dimensional cotton plant shoot architecture segmentation and phenotypic trait characterization using terrestrial LiDAR point cloud data',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:UebtZRa9Y70C',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=51564',
        authors: 'Shangpeng Sun, Changying Li, Andrew Paterson, Peng Chee',
        date: '2020',
        conference: '2020 ASABE Annual International Virtual Meeting',
        award: 'The first-place award at AOC paper competition',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 1
      },
      {
        title: 'Automated plant node detection using terrestrial LiDAR data under field conditions',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:ufrVoPGSRksC',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=50404',
        authors: 'Shangpeng Sun, Changying Li, Andrew Paterson, Jeevan Adhikari, Jon Robertson, Cheng Meng',
        date: '2019',
        conference: '2019 ASABE Annual International Meeting',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 1
      },
      {
        title: 'Eff-PlantNet: an annotation-efficient 3D deep learning network for plant shoot segmentation using point clouds',
        viewUrl: 'https://scholar.google.com/citations?view_op=view_citation&hl=en&user=HzOdf-IAAAAJ&citation_for_view=HzOdf-IAAAAJ:5nxA0vEk-isC',
        detailUrl: 'https://elibrary.asabe.org/abstract.asp?aid=53445',
        authors: 'Liyi Luo, Shangpeng Sun',
        date: '2022',
        conference: '2022 ASABE Annual International Meeting',
        award: 'ITSC oral presentation award',
        volume: '0',
        issue: '0',
        pages: '1',
        publisher: 'American Society of Agricultural and Biological Engineers',
        citedBy: 0
      }
    ]
  }

  journalPapers = []
  conferencePapers = []

  constructor() { }

  ngOnInit(): void {
    this.papers.publicated.forEach(element => {
      let str = ''
      if (element.volume == '' && element.issue == '' && element.pages == '') {
        str = ''
      } else if (element.issue != '0' && element.issue != '') {
        str = element.volume + ' (' + element.issue + '), ' + element.pages
      } else {
        str = element.volume + ', ' + element.pages
      }
      element['book'] = str

      if (element.journal != null) {
        this.journalPapers.push(element)
      }
      if (element.conference != null) {
        this.conferencePapers.push(element)
      }
    });

    this.journalPapers.sort((a: any, b: any) => {
      let aTimestamp = new Date(a['date']).getTime()
      let bTimestamp = new Date(b['date']).getTime()
      return bTimestamp - aTimestamp
    })

    this.conferencePapers.sort((a: any, b: any) => {
      let aTimestamp = new Date(a['date']).getTime()
      let bTimestamp = new Date(b['date']).getTime()
      return bTimestamp - aTimestamp
    })

    // Go to top
    $('html, body').animate({ scrollTop: 0 }, 0);
  }

}
